'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPagesPaths = require('./getPagesPaths');

var _getPagesPaths2 = _interopRequireDefault(_getPagesPaths);

var _ramda = require('ramda');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Checks if a path is in options.pagesPaths
 * @sig Options -> String -> Boolean
 * @param {{pagesPaths: string[]}} options plugin options
 * @param {String} path path to check
 * @return {Result<Boolean>} is in
 */
var isInPagesPaths = function isInPagesPaths(options, path) {
  return (0, _getPagesPaths2.default)(options).map((0, _ramda.filter)(function (pagePath) {
    return (0, _ramda.contains)(pagePath, path);
  })).map((0, _ramda.compose)(_ramda.not, _ramda.isEmpty));
};

exports.default = isInPagesPaths;


//////////////////
// WEBPACK FOOTER
// ./~/ptz-i18n/dist/isInPagesPaths.js
// module id = 311
// module chunks = 34471704633725 35783957827783 216468464745311